export class MaterialDocRequest {
    public material;
    public company_code;
    public language;
}



// WEBPACK FOOTER //
// ./src/app/model/materials/material_doc_request.model.ts